export default "__VITE_ASSET__S4hTCKE4__"